export default __webpack_public_path__ + "static/media/img-new.a167bb16.png";